import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { Subject, Subscription } from 'rxjs';
import { RemoteConfigService } from '../../services/remote-config.service';
import { SocketService } from '../../services/socket.service';
import { LiveService } from '../../services/live.service';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'side-bar',
	templateUrl: './side-bar.component.html',
	styleUrls: ['./side-bar.component.scss']
})
export class SideBarComponent implements OnInit, AfterViewInit, OnDestroy {
	isLive: boolean;
	liveSub: Subscription
	countdownDate: number;
	timeUntilS: string;
    livestreamId: number;

    destroy$ = new Subject<void>();

	constructor(
		private router: Router,
		private app: AppComponent,
        public config: RemoteConfigService,
        private liveService: LiveService) { }

	ngOnInit(): void {

        this.liveService.status$.pipe(takeUntil(this.destroy$)).subscribe(status => {
            if (status == null) {
                return;
            }

            this.isLive = status.isLive;
            if (status.nextStream) {
                this.countdownDate = new Date(status.nextStream).getTime();
            }
            this.checkLiveCountdown();

            if (status.nextStream && status.streams.length > 0) {
                this.livestreamId = status.streams[0].livestreamId;
            } else {
                this.livestreamId = undefined;
            }
        });
	}

	checkLiveCountdown() {
		let intervalId = setInterval(() => {
			// Get today's date and time
			const now = new Date().getTime();

			// Find the distance between now and the count-down date
			const distance = this.countdownDate - now;

			// Time calculations for days, hours, minutes and seconds
			const days = Math.floor(distance / (1000 * 60 * 60 * 24));
			const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((distance % (1000 * 60)) / 1000);

			if (isNaN(days)) {
				return;
			}

			// Display the result in the element with id="demo"
			this.timeUntilS = '';

			if (days > 0) {
				this.timeUntilS = days + 'd ';
				this.timeUntilS += hours + 'h ';
			} else {
				this.timeUntilS += hours + 'h '
					+ minutes + 'm';
			}

			// If the count-down is finished, write some text
			if (distance < 0) {
				clearInterval(intervalId);
				this.timeUntilS = null;
			}
		}, 2000);
	}

	ngAfterViewInit(): void {
	}

	ngOnDestroy() {
		if (this.liveSub) {
			this.liveSub.unsubscribe();
		}
	}

	navigateTo(page: string): void {
		this.router.navigate([`${page}`]);
	}

	isAuthenticated() {
		return this.app.isAuthenticated();
	}

	signout() {
		this.app.signout();
	}

	getAvatarUrl() {
		return this.app.getAvatarUrl();
	}

	startZone(pages: string[]) {
		if (this.router.url === '/' && pages.includes('home')) {
			return true;
		}
		for (let page of pages) {
			if (this.router.url.indexOf(page) > 0) {
				return true;
			}
		}

		return false;
	}

    route(route: string) {
        this.router.navigate([route]);
    }
}
